import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[accordionHeader]',
    standalone: false
})
export class AccordionHeaderDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
